class Website {
  '_id'?: string;
  'domain'?: string;
  'title'?: string;
  'background'?: string;
  'color'?: string;
  'titleBarColor'?: string;
  'date'?: Date;
  'api'?: {
    'url'?: string;
    'secret'?:  string;
    'key'?: string;
  };
  'order'?: number;
  'accountingCode'?: string;
}

export {
  Website,
};